import { Stack, styled } from "@mui/material";
import { toolbarButtonGroupClasses, toolbarButtonGroupName } from "../classes.js";
const excludedProps = ["as", "cssVariables", "ownerState", "sx", "theme"];
const anchorBottom = `&.${toolbarButtonGroupClasses.anchorBottom}`;
const anchorTop = `&.${toolbarButtonGroupClasses.anchorTop}`;
const Root = styled(Stack, {
  name: toolbarButtonGroupName,
  overridesResolver: (_props, styles) => [styles.root],
  shouldForwardProp: (prop) => !excludedProps.includes(prop),
  slot: "Root"
})(({ cssVariables: vars }) => ({
  backgroundColor: vars.buttonGroupBackgroundColor,
  color: vars.buttonGroupColor,
  flexDirection: "column",
  justifyContent: "flex-start",
  marginTop: 0,
  width: "100%",
  [anchorTop]: {
    flex: "1 1 auto",
    marginBottom: "auto"
  },
  [anchorBottom]: {
    flex: "0 0 auto",
    justifyContent: "flex-end",
    marginBottom: 0,
    marginTop: "auto"
  }
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
